import { BehaviorSubject, of, throwError, filter, catchError, tap, map, switchMap } from 'rxjs';
import { Branch } from '../enums/Branch';
import { convertUnixToDate as convertUnixToDateU } from '@golden/utils';
import { startOfMinute, getMinutes, getTime, addMinutes, getSeconds, addSeconds } from 'date-fns';
export function getOnTimeDiffMS(denominator) {
    const { minuteDenominator, secondDenominator } = denominator;
    const now = new Date();
    const ceilNow = addMinutes(startOfMinute(now), 1);
    const nowMinutes = getMinutes(ceilNow);
    let diffMinutes = 0;
    let diffSeconds = 0;
    const nowSeconds = getSeconds(ceilNow);
    if (minuteDenominator !== 0) {
        const remainderMinutes = nowMinutes % minuteDenominator;
        if (remainderMinutes !== 0) {
            diffMinutes = minuteDenominator - remainderMinutes;
        }
    }
    if (secondDenominator !== 0) {
        const remainderSeconds = nowSeconds % secondDenominator;
        if (remainderSeconds !== 0) {
            diffSeconds = secondDenominator - remainderSeconds;
        }
    }
    let nextTime = addMinutes(ceilNow, diffMinutes);
    nextTime = addSeconds(nextTime, diffSeconds);
    return getTime(nextTime) - getTime(now);
}
export function convertBranchLikeToBranch(branch) {
    if (typeof branch === 'string') {
        return branch;
    }
    return branch.branch;
}
export function isBranchEqual(source, target) {
    return convertBranchLikeToBranch(source) === convertBranchLikeToBranch(target);
}
export function createBranch(config) {
    const value = new BehaviorSubject(config.value);
    let latestBranchConfig = config.branch;
    const getCachedBranchConfig = (branchLike) => {
        if (!isBranchEqual(branchLike, config.branch)) {
            throw new Error('branchToApi: branch not equal');
        }
        if (typeof config.branch === 'string') {
            return branchLike;
        }
        if (typeof branchLike === 'string') {
            return latestBranchConfig;
        }
        latestBranchConfig = branchLike;
        return branchLike;
    };
    const obs = config.trunk.asObservable().pipe(tap(([branches]) => {
        if (branches.some((b) => isBranchEqual(b, Branch.CLEAR))) {
            value.next(config.value);
        }
    }), filter(([branches]) => branches.some((b) => isBranchEqual(b, config.branch))), switchMap(([branches, handleError]) => of(branches.reverse().find((b) => isBranchEqual(b, config.branch)) ?? config.branch).pipe(map((branchLike) => getCachedBranchConfig(branchLike)), config.operator, catchError((error) => throwError(() => [branches, handleError, error])))), catchError((errorData, source) => {
        const [branches, handleError, error] = errorData;
        handleError(error, branches);
        return source;
    }));
    obs.subscribe(value);
    return value;
}
export const convertUnixToDate = convertUnixToDateU;
//# sourceMappingURL=ServiceUtils.js.map